import React, { FC, useCallback } from 'react';
import {
  SubscriptionActionModalText,
  SubscriptionActionModalTitle,
} from '../../CancelSubscriptionModal/CancelSubscriptionModal.style';
import { FormattedMessage, useIntl } from 'react-intl';
import { CustomButton } from '@mindly/ui-components';
import { useIonAlert } from '@ionic/react';

type FirstStepProps = {
  handleNextStep: () => void;
};

const FirstStep: FC<FirstStepProps> = ({ handleNextStep }) => {
  const intl = useIntl();
  const [present] = useIonAlert();

  const handlePauseSubscription = useCallback(() => {
    present({
      mode: 'ios',
      header: intl.formatMessage({
        id: 'general.please.confirm',
        defaultMessage: 'Будь-ласка підтвердіть',
      }),
      buttons: [
        {
          text: intl.formatMessage({
            id: 'subscription.pause.btn',
            defaultMessage: 'Призупинити',
          }),
          cssClass: 'confirm-delete-button',
          handler: async () => {
            handleNextStep();
          },
        },
        {
          text: intl.formatMessage({
            id: 'general.no',
            defaultMessage: 'Ні',
          }),
        },
      ],
    });
  }, [intl]);

  return (
    <div className={'first-step-wrapper'}>
      <SubscriptionActionModalTitle>
        <FormattedMessage id={'subscription.pause.step.1.title'} defaultMessage={'Призупинити підписку'} />
      </SubscriptionActionModalTitle>
      <SubscriptionActionModalText>
        <FormattedMessage
          id={'subscription.pause.step.1.text'}
          defaultMessage={'Призупиніть план на скільки Вам потрібно.'}
        />
      </SubscriptionActionModalText>
      <CustomButton buttonType={'primary'} className={'first-step-btn'} onClick={handlePauseSubscription}>
        <FormattedMessage id={'subscription.set.pause.title'} defaultMessage={'Призупинити підписку'} />
      </CustomButton>
    </div>
  );
};

export default FirstStep;
